module.exports = __webpack_public_path__ + "img/artikel.1788e118.jpg";